import React from 'react';
import { Container, Image } from 'react-bootstrap';
 // Ensure this CSS file exists (we'll create it below)

// Placeholder image imports (replace with actual image paths)
import ShashikantImage from '../images/bbb.jpg';
import JitendraImage from '../images/bbb.jpg';
import RaviImage from '../images/bbb.jpg';
import PreetiImage from '../images/aaa.jpg';

interface TeamMember {
  name: string;
  image: string;
  description: string;
  designation?: string;
}

const CoreTeam: React.FC = () => {
  const teamMembers: TeamMember[] = [
    {
      name: 'Shashikant Mishra',
      image: ShashikantImage,
      designation: 'Director, Srisailam Foundation',
      description:
        "Shashikant Mishra is an IT professional with over 15 years of experience in the technology sector. Alongside his professional career, he serves as a Director of Srisailam Foundation in a voluntary and unpaid capacity.\n\nHe is passionate about supporting children's education and believes that access to learning opportunities can make a meaningful difference in their lives.\n\nThrough his personal involvement with the Foundation, he supports its efforts to provide free education and learning support to children studying up to Class 8 in Raebareli, Uttar Pradesh.\n\nHis involvement with Srisailam Foundation is independent of his professional employment and reflects his personal commitment to community welfare and education.",
    },
    {
      name: 'Jitendra Kumar Yadav',
      image: JitendraImage,
      description:
        'I have over 10 years of experience in the education field, particularly guiding students preparing for civil services. Additionally, I have been involved in the medical field. Through my work, I have witnessed firsthand how people in rural and underprivileged areas struggle to access proper medical care due to financial limitations. This realization deeply moved me and inspired me to dedicate myself to more meaningful work through a non-profit organization (NGO). I believe it is time to use my skills and experience to serve a greater purpose by helping improve the health and well-being of those who need it most.',
    },
    {
      name: 'Ravi Kant Mishra',
      image: RaviImage,
      description:
        'I have more than 10 years of experience in the accounts and finance sector. Additionally, I have worked on a Women Empowerment and Livelihood Program supported by NABARD and implemented by the Ministry of Women and Child Development. Through this experience, I learned how to empower women, particularly those in poor and rural areas, helping them improve their lives. Currently, I am working in the health sector, specifically in the accounts and finance department, under the Ministry of Health and Family Welfare. Over time, I have gained deep insights into how to help the poor and marginalized, especially women, children, and senior citizens, with their health challenges. This realization has driven me to pursue more meaningful work in the non-profit organization (NGO). While I see my current role as a small step in my journey, I know there is so much more to be done. My goal is to focus on areas such as education, health, women empowerment, child care, and humanitarian aid for the hungry. We are not just making an effort; we are starting a revolution. Our mission is to ensure that no one is left hungry, uneducated, powerless, or unhealthy. We are committed to making a real difference in the lives of those in need.',
    },
    {
      name: 'Preeti Yadav',
      image: PreetiImage,
      description:
        'I am an Advocate in The High Court and a dedicated social worker who has worked for 5 years in the field of education and women empowerment. I am interested in bringing positive changes in society and helping weaker sections.',
    },
  ];

  return (
    <section className="sf-core-team tw-py-[clamp(3rem,6vw,5rem)]">
      <Container className="sf-core-team-container">
        <h1 className="sf-core-team-title">Our Leadership Team</h1>
        <div className="tw-grid tw-gap-6 md:tw-gap-8">
          {teamMembers.map((member) => (
            <article key={member.name} className="sf-core-team-card tw-grid tw-items-start tw-gap-6 md:tw-grid-cols-[minmax(0,1fr)_minmax(0,2fr)] md:tw-gap-10">
              <div className="tw-w-full tw-max-w-[280px] tw-mx-auto">
                <Image
                  src={member.image}
                  alt={`${member.name}'s profile`}
                  className="sf-core-team-avatar tw-block tw-h-auto tw-w-full"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://via.placeholder.com/300x300?text=No+Image';
                  }}
                />
              </div>
              <div>
                <h2 className="sf-core-team-name">{member.name}</h2>
                {member.designation && <p className="tw-mb-3 tw-font-semibold tw-text-sf-ink">{member.designation}</p>}
                <div className="tw-mb-4 tw-h-1 tw-w-12 tw-rounded-full tw-bg-sf-teal" aria-hidden="true" />
                <p className={`sf-core-team-description${member.designation ? ' tw-whitespace-pre-line' : ''}`}>{member.description}</p>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default CoreTeam;
